import axios from 'axios'
import URL_ROUTE from '../../constants/index'

// Endpoints que no deben disparar el redireccionamiento por sesión expirada
// (ej: login, donde un 401 significa "credenciales inválidas", no "token expirado")
const EXCLUDED_URLS = [URL_ROUTE.LOGIN, URL_ROUTE.RECOVERYPASS]

let installed = false

const isExcluded = (input) => {
    const url = typeof input === 'string' ? input : (input && input.url) || ''
    return EXCLUDED_URLS.some(excluded => excluded && url.includes(excluded))
}

const handleSessionExpired = () => {
    if (window.location.pathname === '/login') return

    sessionStorage.clear()

    // Fuerza una recarga completa para que el estado de autenticación
    // (UserContext, redux) se reinicie desde cero y el Router muestre el login.
    window.location.href = '/login'
}

/**
 * Instala un interceptor global sobre `fetch` y sobre `axios` que detecta
 * respuestas 401 (token inválido o expirado) y redirige automáticamente
 * al login. Cubre así todas las formas en que el proyecto hace peticiones
 * al backend (los providers en `src/providers/*` usan `fetch`, mientras
 * que algunas vistas/hooks usan `axios`).
 */
export const setupAuthInterceptor = () => {
    if (installed) return
    installed = true

    const originalFetch = window.fetch.bind(window)

    window.fetch = async (...args) => {
        const response = await originalFetch(...args)

        if (response.status === 401 && !isExcluded(args[0])) {
            handleSessionExpired()
        }

        return response
    }

    axios.interceptors.response.use(
        response => response,
        error => {
            const status = error && error.response && error.response.status
            const url = error && error.config && error.config.url

            if (status === 401 && !isExcluded(url)) {
                handleSessionExpired()
            }

            return Promise.reject(error)
        }
    )
}
